import { Box, Button } from '@mui/material';
import { BusTypes } from '../../@types/lines';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { useProvideSnackBar } from '../../hooks';
import { usePreconfiguredFetch } from '../../hooks/useProvidePreconfiguredFetch';

interface NewLineProps {
    requirements: any;
    afterCreate: () => void;
    nextLineName: string;
}

export default function NewLine({ requirements, afterCreate, nextLineName }: NewLineProps) {
    const { fetchResource } = usePreconfiguredFetch();
    const { showResponseError } = useProvideSnackBar();

    const createNewLine = async () => {
        const response = await fetchResource('/api/lines', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                Lines: requirements.map((item: any) => {
                    return {
                        RequirementID: item.ID,
                        Capacity: BusTypes[3].capacity,
                        CrmID: item.CrmID,
                    };
                }),
                LineName: nextLineName,
            }),
        });

        if (!response.ok) {
            await showResponseError(response);
            return;
        }
        afterCreate();
    };

    return (
        <Box display={'flex'} justifyContent={'center'}>
            <Button
                variant={'contained'}
                color='primary'
                size={'small'}
                onClick={() => createNewLine()}
                sx={{ borderRadius: '50px', width: '100%', textAlign: 'center' }}>
                <AddCircleIcon sx={{ padding: 0.25 }} />
                Új járat
            </Button>
        </Box>
    );
}
